module.exports = __webpack_public_path__ + "img/sgccbz.8e56f2dc.jpg";